import { app } from './firebaseApp';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

// This module is imported eagerly (via analytics.js) on every page, so it
// must stay light — Auth/Firestore/Storage live in ./partnerFirebase, which
// only the lazy-loaded partner-onboarding pages import.

// Analytics only loads in browsers that support it (blocked by some ad-blockers/older browsers).
let analyticsInstance = null;
isSupported().then(supported => {
  if (supported) analyticsInstance = getAnalytics(app);
}).catch(() => {});

export function trackEvent(name, params) {
  if (analyticsInstance) logEvent(analyticsInstance, name, params);
}
